import {app} from "../../../config/constants"

export const getSettings = (uid) => {
	return app.database().ref( 'cams/settings/users' ).child(uid).once('value', userSettingsSnap => {})
};

export const saveSettings = (uid, settings) => {
	return app.database().ref('cams/settings/users').child(uid).set(settings);
};


// WEBPACK FOOTER //
// ./src/api/settings/user/index.js